/**
 * Copyright 2021-2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { SectionRow } from '@umati/dashboard-types';
import React, { Component } from 'react';
import TemplateHelper from '../../../utilities/TemplateHelper';
import SectionElementContent from './SectionElementContent';

export interface SectionRowContentProps {
  row: SectionRow;
  cols: string;
  data: any;
  sectionIndex: number;
  sectionDataIndex: number;
  rowIndex: number;
  rowDataIndex: number;
  title?: string;
}

export interface SectionRowContentState {}

export default class SectionRowContent extends Component<SectionRowContentProps, SectionRowContentState> {
  constructor(props: SectionRowContentProps) {
    super(props);
    this.state = {};
  }

  render() {
    if (!TemplateHelper.checkRenderingCondition(this.props.data, this.props.row.condition)) {
      return <></>;
    }

    return (
      <div className="section">
        {this.props.title && (
          <div className="row">
            <div className="col">
              <h4 className="h5">{this.props.title}</h4>
            </div>
          </div>
        )}
        <div className="row">
          {this.props.row.elements.map((element, elementIndex) => (
            <>
              {!element.isPlaceholder && (
                <SectionElementContent
                  key={TemplateHelper.getKeyElement(
                    this.props.sectionIndex,
                    this.props.sectionDataIndex,
                    this.props.rowIndex,
                    this.props.rowDataIndex,
                    elementIndex,
                  )}
                  cols={this.props.cols}
                  data={this.props.data}
                  element={element}
                />
              )}
              {element.isPlaceholder && (
                <>
                  {TemplateHelper.getPlaceholderObjects(this.props.data, element.placeholderObject).map(
                    (innerData, innerDataIndex) => (
                      <SectionElementContent
                        key={TemplateHelper.getKeyElement(
                          this.props.sectionIndex,
                          this.props.sectionDataIndex,
                          this.props.rowIndex,
                          this.props.rowDataIndex,
                          elementIndex,
                          innerDataIndex,
                        )}
                        cols={this.props.cols}
                        data={innerData}
                        element={element}
                      />
                    ),
                  )}
                </>
              )}
            </>
          ))}
        </div>
      </div>
    );
  }
}
